/*
 * Adapptio Editor
 *
 * @package editor
 * @copyright 2021-2025 Hexio a.s. <contact@hexio.io> (hexio.io) and contributors.
 * @license Apache-2.0
 *
 * See LICENSE file distributed with this source code for more information.
 */

export * from "./animate";
export * from "./computeRelativeOffset";
export * from "./createChainedFunction";
export * from "./debounce";
export * from "./getAutoHeightDuration";
export * from "./getBasePopperPlacement";
export * from "./getBoundingClientRect";
export * from "./getElementScroll";
export * from "./getOwnerDocument";
export * from "./getOwnerWindow";
export * from "./getPopperPlacementVariation";
export * from "./getRelativeRect";
export * from "./getScrollableParents";
export * from "./getScrollbarSize";
export * from "./getScrollParent";
export * from "./isElementScrollable";
export * from "./isMouseEventInElementArea";
export * from "./isShadowRoot";
export * from "./setRef";
export * from "./toPx";
